import { Card, Dialog, DialogContent, DialogTitle, Divider, Grid } from "@material-ui/core";

import React, { useState } from "react";
import { Button, FormDataConsumer, SelectInput, TextInput, useDataProvider, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { SectionTitle } from "../../../Components/SectionTitle";
import { Separator } from "../../../Components/Separator";
import ReliabilityReportRemarkTimeline from "../ReliabilityReportRemarks";
import { Add, Update } from "@material-ui/icons";
import { ReliabilityReportRemarkCreateModel } from "../Models/ReliabilityReportRemarkCreateModel";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { ReliabilityReportUpdateModel } from "../Models/ReliabilityReportModels";
import { ReliabilityReportStatusChoices } from "../../../../src/Enums/ReliabilityReportStatus";
import { ReliabilityFofStatus } from "../../../../src/Enums/ReliabilityFoFStatus";
import { useAuth } from "@airborne/react-admin";
import {
  ReliabilityPrematureFailureChoices,
  ReliabilityPrematureFailureStatus,
} from "../../../../src/Enums/ReliabilityPrematureFailureStatus";
import { ReliabilityThyPrematureFailureUpdateModel } from "../Models/ReliabilityThyPrematureFailureModel";
import {
  ReliabilityNotPrematureFailureReasonType,
  ReliabilityPrematureFailureReasonType,
  ReliabilityPrematureFailureRejectReasonType,
} from "../../../../src/Enums/ReliabilityPrematureFailureReasonType";
import ReliabilityOtherConditions from "../ReliabilityOtherConditions";

export const ThyPrematureFailureDetail = props => {
  const provider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({} as any);
  const notify = useNotify();
  const [isReliabilityReportButtonShow, setIsReliabilityReportButtonShow] = useState(false);
  const [isThyPrematureFailureButtonShow, setIsThyPrematureFailureButtonButtonShow] = useState(false);
  const [isDisabledReportFields, setIsDisabledReportFields] = useState(true);
  const [isDisabledThyPrematureFailureFields, setIsDisabledThyPrematureFailureFields] = useState(true);
  const [isReasonRequired, setIsReasonRequired] = useState(false);
  const [isThyPrematureFailure, setisThyPrematureFailure] = useState(null as any);
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();

  React.useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    provider
      .getOne("reliabilitythyprematurefailures", {
        id: props.id,
      })
      .then(response => {
        setData(response.data);

        if (
          response.data.prematureFailureStatus === ReliabilityPrematureFailureStatus.Rejected ||
          response.data.prematureFailureStatus === ReliabilityPrematureFailureStatus.NotPrematureFailure
        ) {
          response.data.prematureFailureStatus === ReliabilityPrematureFailureStatus.Rejected
            ? setisThyPrematureFailure(false)
            : setisThyPrematureFailure(true);
          setIsReasonRequired(true);
        } else {
          setIsReasonRequired(false);
        }
      })
      .catch(error => {});
  };

  const editReliabilityReport = e => {
    setIsReliabilityReportButtonShow(true);
    setIsDisabledReportFields(false);
  };

  const editReliabilityReportButtonClick = formValues => e => {
    let reliabilityReport: ReliabilityReportUpdateModel = new ReliabilityReportUpdateModel();
    reliabilityReport.Id = data?.report?.id;
    reliabilityReport.GoodsRcvdBatch = data?.report?.goodsRcvdBatch;
    reliabilityReport.Pn = data?.report?.pn;
    reliabilityReport.Sn = data?.report?.sn;
    reliabilityReport.Chapter = data?.report?.chapter;
    reliabilityReport.ReportType = data?.report.reportType;
    reliabilityReport.ReportStatus = formValues.reportStatus;
    reliabilityReport.TargetDate = formValues.targetDate;

    dataProvider
      .putReliabilityReport(reliabilityReport)
      .then(result => {
        notify(`Reliability Report Updated`, "success", false, true);
        setIsReliabilityReportButtonShow(false);
        setIsDisabledReportFields(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CancelEditingReliabilityReport = e => {
    setIsReliabilityReportButtonShow(false);
    setIsDisabledReportFields(true);
  };

  const editThyPrematureFailure = e => {
    setIsThyPrematureFailureButtonButtonShow(true);
    setIsDisabledThyPrematureFailureFields(false);
  };

  const editThyPrematureFailureButtonClick = e => {
    let reliabilityThyPrematureFailure: ReliabilityThyPrematureFailureUpdateModel =
      new ReliabilityThyPrematureFailureUpdateModel();
    reliabilityThyPrematureFailure.Id = data?.id;
    reliabilityThyPrematureFailure.ReportId = data?.reportId;
    reliabilityThyPrematureFailure.Batch = data?.batch;
    reliabilityThyPrematureFailure.BeforeRemovalOrderType = data?.beforeRemovalOrderType;
    reliabilityThyPrematureFailure.BeforeRemovalOrderNumber = data?.beforeRemovalOrderNumber;
    reliabilityThyPrematureFailure.BeforeRemovalOrderStatus = data?.beforeRemovalOrderStatus;
    reliabilityThyPrematureFailure.BeforeRemovalVendorType = data?.beforeRemovalVendorType;
    reliabilityThyPrematureFailure.BeforeRemovalVendor = data?.beforeRemovalVendor;
    reliabilityThyPrematureFailure.BeforeRemovalCondition = data?.beforeRemovalCondition;
    reliabilityThyPrematureFailure.AfterRemovalOrderType = data?.afterRemovalOrderType;
    reliabilityThyPrematureFailure.AfterRemovalOrderNumber = data?.afterRemovalOrderNumber;
    reliabilityThyPrematureFailure.AfterRemovalOrderStatus = data?.afterRemovalOrderStatus;
    reliabilityThyPrematureFailure.AfterRemovalVendorType = data?.afterRemovalVendorType;
    reliabilityThyPrematureFailure.AfterRemovalVendor = data?.afterRemovalVendor;
    reliabilityThyPrematureFailure.AfterRemovalCondition = data?.afterRemovalCondition;
    reliabilityThyPrematureFailure.AcReg = data?.acReg;
    reliabilityThyPrematureFailure.AcType = data?.acType;
    reliabilityThyPrematureFailure.FleetType = data?.fleetType;
    reliabilityThyPrematureFailure.AcRemoveDate = data?.acRemoveDate;
    reliabilityThyPrematureFailure.PrematureFailureStatus = e.prematureFailureStatus;
    reliabilityThyPrematureFailure.Reason = e.reason;
    reliabilityThyPrematureFailure.OtherReason = e.otherReason;

    dataProvider
      .putReliabilityThyPrematureFailure(reliabilityThyPrematureFailure)
      .then(result => {
        notify(`Reliability THY Premature Failure Updated`, "success", false, true);
        setIsThyPrematureFailureButtonButtonShow(false);
        setIsDisabledThyPrematureFailureFields(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CancelEditingPrematureFailure = e => {
    setIsThyPrematureFailureButtonButtonShow(false);
    setIsDisabledThyPrematureFailureFields(true);
  };

  const AddReliabilityReportRemarkButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const AddReliabilityReportRemarkButtonClick = props => e => {
      let reliabilityRemark: ReliabilityReportRemarkCreateModel = new ReliabilityReportRemarkCreateModel();

      reliabilityRemark.ReliabilityReportId = props.reliabilityReportId;
      reliabilityRemark.IsVisibleToCustomer = true;
      reliabilityRemark.Remark = e.remark;

      dataProvider
        .postReliabilityReportRemark(reliabilityRemark)
        .then(result => {
          notify(`Reliability THY Report Remark Added`, "success", false, true);
          history.go(0);
          setOpen(false);
        })
        .catch(result => notify(`${result}`, "error", false, true))
        .finally(() => setLoading(false));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <Button label="Add Remark" disabled={loading} size="medium" variant="contained" onClick={handleClick}>
          {<Add />}
        </Button>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reliability Report Remark</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={AddReliabilityReportRemarkButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <TextInput source="remark" label="remark" size="medium" fullWidth variant="outlined" />
                  <Button label={"Add Remark!"} size="large" variant="contained" onClick={handleSubmit}>
                    <Update />
                  </Button>
                  <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                    <Update />
                  </Button>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const CheckValidate = e => {
    if (e.target.value === ReliabilityFofStatus.Rejected || e.target.value === ReliabilityFofStatus.NotFof) {
      e.target.value === ReliabilityFofStatus.Rejected
        ? setisThyPrematureFailure(false)
        : setisThyPrematureFailure(true);
      setIsReasonRequired(true);
    } else {
      setIsReasonRequired(false);
    }
  };

  return (
    <>
      <Form
        onSubmit={() => {}}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Card>
                <Grid container spacing={0} style={{ padding: 25 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Reliability Report Details" />
                    <Divider style={{ padding: 0 }} />
                    <Separator />
                  </Grid>

                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="goodsRcvdBatch"
                      label="Goods Received Batch"
                      initialValue={data?.report?.goodsRcvdBatch}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="chapter"
                      label="Chapter"
                      initialValue={data?.report?.chapter}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <SelectInput
                      source="reportStatus"
                      label="Report Status"
                      initialValue={data?.report?.reportStatus}
                      choices={ReliabilityReportStatusChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      disabled={isDisabledReportFields}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="pn"
                      label="PN"
                      initialValue={data?.report?.pn}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="pnDescription"
                      initialValue={data?.pnDescription}
                      label="PN Description"
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <CustomDatetime
                      source="targetDate"
                      label="Target Date"
                      initialValue={data?.report?.targetDate}
                      fullWidth
                      showTime
                      disabled={isDisabledReportFields}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="sn"
                      label="SN"
                      initialValue={data?.report?.sn}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="pnSubCategory"
                      label="SUB Category"
                      initialValue={data?.pnSubCategory}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "start", margin: 10 }}>
                  <SectionTitle label="Reliability Other Condition" />
                  {data?.report?.goodsRcvdBatch != undefined && (
                    <ReliabilityOtherConditions goodsRcvdBatch={data?.report?.goodsRcvdBatch} />
                  )}
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && !isReliabilityReportButtonShow && (
                    <Button
                      label="Edit Reliability Report"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editReliabilityReport}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isReliabilityReportButtonShow && (
                    <Button
                      label="Edit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editReliabilityReportButtonClick(values)}
                      style={{ margin: "8px", background: "#4caf50" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isReliabilityReportButtonShow && (
                    <Button
                      label="Cancel"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={CancelEditingReliabilityReport}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                </Grid>
                <ReliabilityReportRemarkTimeline
                  reliabilityReportRemark={data?.reliabilityReportRemark}
                  refresh={getData}
                  isCustomerRelated={false}
                />
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  <AddReliabilityReportRemarkButton reliabilityReportId={data?.report?.id} />
                </Grid>
              </Card>
            </form>
          );
        }}
      ></Form>

      <Separator />

      <Form
        initialValues={data}
        onSubmit={editThyPrematureFailureButtonClick}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Card>
                <Grid container spacing={0} style={{ padding: 25 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="THY Premature Failure Details" />
                    <Divider style={{ padding: 0 }} />
                    <Separator />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="batch"
                      label="Batch"
                      initialValue={data?.batch}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalOrderType"
                      label="Before Removal Order Type"
                      initialValue={data?.beforeRemovalOrderType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalOrderNumber"
                      label="Before Removal Order Number"
                      initialValue={data?.beforeRemovalOrderNumber}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalVendorType"
                      label="Before Removal Vendor Type"
                      initialValue={data?.beforeRemovalVendorType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalVendor"
                      label="Before Removal Vendor"
                      initialValue={data?.beforeRemovalVendor}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="beforeRemovalCondition"
                      label="Before Removal Condition"
                      initialValue={data?.beforeRemovalCondition}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <TextInput
                      source="acReg"
                      label="AC Reg"
                      initialValue={data?.ac}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <CustomDatetime
                      source="acRemoveDate"
                      label="AC Remove Date"
                      initialValue={data?.acRemoveDate}
                      fullWidth
                      showTime
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalOrderType"
                      label="After Removal Order Type"
                      initialValue={data?.afterRemovalOrderType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalOrderNumber"
                      label="After Removal Order Number"
                      initialValue={data?.afterRemovalOrderNumber}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalVendorType"
                      label="After Removal  Vendor Type"
                      initialValue={data?.afterRemovalVendorType}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalVendor"
                      label="After Removal Vendor"
                      initialValue={data?.afterRemovalVendor}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="afterRemovalCondition"
                      label="After Removal Condition"
                      initialValue={data?.afterRemovalCondition}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={4} lg={3} style={{ margin: 25 }}>
                    <SelectInput
                      source="prematureFailureStatus"
                      label="Premature Failure Status"
                      initialValue={data?.prematureFailureStatus}
                      choices={ReliabilityPrematureFailureChoices}
                      optionText="key"
                      optionValue="value"
                      fullWidth
                      onChange={CheckValidate}
                      disabled={isDisabledThyPrematureFailureFields}
                      variant="outlined"
                    />

                    {isReasonRequired && (
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        initialValue={data?.reason}
                        choices={
                          isThyPrematureFailure
                            ? ReliabilityNotPrematureFailureReasonType
                            : ReliabilityPrematureFailureRejectReasonType
                        }
                        optionText="key"
                        optionValue="value"
                        fullWidth
                        disabled={isDisabledThyPrematureFailureFields}
                        variant="outlined"
                      />
                    )}

                    <FormDataConsumer>
                      {({ formData, ...rest }) =>
                        formData.reason === ReliabilityPrematureFailureReasonType.Other &&
                        isReasonRequired && (
                          <TextInput
                            source="otherReason"
                            label="Other Reason"
                            initialValue={data?.otherReason}
                            fullWidth
                            variant="outlined"
                            disabled={isDisabledThyPrematureFailureFields}
                            multiline
                            {...rest}
                          />
                        )
                      }
                    </FormDataConsumer>
                  </Grid>
                </Grid>
                <Grid container spacing={0} style={{ padding: 25, justifyContent: "end" }}>
                  {!user?.isCustomer && !isThyPrematureFailureButtonShow && (
                    <Button
                      label="Edit THY Premature Failure"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={editThyPrematureFailure}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isThyPrematureFailureButtonShow && (
                    <Button
                      label="Edit"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={handleSubmit}
                      style={{ margin: "8px", background: "#4caf50" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                  {isThyPrematureFailureButtonShow && (
                    <Button
                      label="Cancel"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      onClick={CancelEditingPrematureFailure}
                      style={{ margin: "8px", background: "#ffc107" }}
                    >
                      {<Update />}
                    </Button>
                  )}
                </Grid>
              </Card>
            </form>
          );
        }}
      ></Form>
    </>
  );
};

export default ThyPrematureFailureDetail;
